/* eslint-disable no-extend-native */
export {};
declare global {
    interface ReadableStream {
        toUint8Array(): Promise<Uint8Array>;
        toBlob(): Promise<Blob>;
        toDataUrl(): Promise<string>;
        toText(): Promise<string>;
    }
}

if (!ReadableStream.prototype.toUint8Array) {
    ReadableStream.prototype.toUint8Array = async function toUint8Array(
        this: ReadableStream<Uint8Array>,
    ): Promise<Uint8Array> {
        // Use a reader to get the data chunks
        const reader = this.getReader();
        const chunks = [];
        let totalLength = 0;

        while (true) {
            // Read a chunk from the stream
            const { done, value } = await reader.read();

            if (done) {
                break; // The stream has ended
            }

            if (value instanceof Uint8Array) {
                chunks.push(value);
                totalLength += value.byteLength;
            } else {
                // Handle potential errors if the stream produces non-Uint8Array chunks
                throw new TypeError("Received non-Uint8Array chunk");
            }
        }

        // Concatenate all chunks into a single Uint8Array
        const result = new Uint8Array(totalLength);
        let offset = 0;
        for (const chunk of chunks) {
            result.set(chunk, offset);
            offset += chunk.byteLength;
        }

        return result;
    };
}

if (!ReadableStream.prototype.toBlob) {
    ReadableStream.prototype.toBlob = async function toBlob(
        this: ReadableStream<Uint8Array>,
    ): Promise<Blob> {
        return new Blob([await this.toUint8Array() as any]);
    };
}

if (!ReadableStream.prototype.toDataUrl) {
    ReadableStream.prototype.toDataUrl = async function toDataUrl(
        this: ReadableStream<Uint8Array>,
    ): Promise<string> {
        return await (await this.toBlob()).toDataUrl();
    };
}

if (!ReadableStream.prototype.toText) {
    ReadableStream.prototype.toText = async function toText(
        this: ReadableStream<Uint8Array>,
    ): Promise<string> {
        return await (await this.toBlob()).toText();
    };
}
